import isString from 'lodash/isString'

export const currencyMap = {
  rub: '₽',
  usd: '$',
  eur: '€',
}

const currencyInPrefix = ['usd', 'eur']

function getCurrency(currency) {
  if (!currency) {
    return ''
  }

  const alias = currency.toLowerCase()
  return alias in currencyMap ? currencyMap[alias] : currency
}

const format = (amount, currency = '', i18n = false) => {
  const locale = i18n || global.locale

  const symbol = getCurrency(currency)

  const prefix = isString(currency) ? currencyInPrefix.indexOf(currency.toLowerCase()) > -1 : ''

  const values = parseFloat(amount).toFixed(2).split('.')
  const decimal = parseInt(values[0]).toLocaleString(locale)
  const fraction = (locale === 'ru' ? ',' : '.') + values[1]

  if (prefix) {
    return symbol + ' ' + decimal + '<span class="currency">' + fraction + '</span>'
  } else {
    return decimal + '<span class="currency">' + fraction + ' ' + symbol + '</span>'
  }
}

export default format

export const formatByLocale = (value, i18n, options = {}) => {
  return (Number(value) || 0).toLocaleString(i18n || global.locale, {
    ...options,
  })
}

export const formatToString = (amount, currency, fractionDigits = 2) => {
  const locale = global.locale

  const symbol = getCurrency(currency)
  const prefix = currencyInPrefix.indexOf(currency.toLowerCase()) > -1

  const values = parseFloat(amount).toFixed(fractionDigits).split('.')
  const decimal = parseInt(values[0]).toLocaleString(global.locale)
  const fraction = (locale === 'ru' ? ',' : '.') + values[1]

  if (prefix) {
    return symbol + ' ' + decimal + fraction
  } else {
    return decimal + fraction + ' ' + symbol
  }
}
